import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import PageHeader from "../../../components/PageHeader";
import DataTable from "../../../components/DataTable";
import Loading from "../../../components/Loading";
import { getFilterState, saveFilterState } from "../../../utils";
import { WORK_ORDER_COLUMNS } from "./columns";
import { ALL_WORK_ORDERS_VIEW_BY_PAGE_QUERY } from "../../../graphql/WorkOrders/WorkOrders.graphql";
import WorkOrderFilters from "./WorkOrderFilters";
import { useSystemCodes } from "../../../utils/hooks";

const DEFAULT_FILTERS = {
  CreatedDateTime_gte:
    new Date().setHours(0, 0, 0, 0) - 1000 * 60 * 60 * 24 * 365 * 2
};

function WorkOrdersPage() {
  const SystemCodes = useSystemCodes({
    Category: "Fleet",
    CodeName: "WOStatus"
  });
  const SystemCodesVehicles = useSystemCodes({
    Category: "Fleet",
    CodeName: "VehicleStatus",
    CodeDescription_not: "Terminated"
  });
  const history = useHistory();
  const INITIAL_FILTER_STATE = getFilterState("WORK_ORDERS_FILTERS");
  const [filters, setFilters] = useState({
    ...INITIAL_FILTER_STATE,
    ...DEFAULT_FILTERS
  });

  useEffect(() => {
    // Setting up the default filters on start
    if (!filters) {
      const Filters = {};
      Object.keys(INITIAL_FILTER_STATE).forEach(
        key =>
          (Filters[key] =
            INITIAL_FILTER_STATE[key] && INITIAL_FILTER_STATE[key].value
              ? INITIAL_FILTER_STATE[key].value
              : INITIAL_FILTER_STATE[key])
      );

      setFilters(Filters);
    }
    if (SystemCodes?.data?.length > 0 && !filters.WOStatusRecIdRef_in) {
      const newFilters = SystemCodes.data.filter(s => s.CodeId !== "PST");
      setFilters({
        ...filters,
        WOStatusRecIdRef_in: newFilters.map(f => f.RecId)
      });
    }
  }, [filters, INITIAL_FILTER_STATE, SystemCodes, SystemCodesVehicles.data]);

  const handleSetFilters = inputs => {
    // Clearing filters if is empty and avoid null response from query
    Object.keys(inputs).forEach(
      key =>
        (!inputs[key] ||
          inputs[key] === 0 ||
          inputs[key] === "" ||
          inputs[key].length === 0) &&
        delete inputs[key]
    );
    // Seting up the Filters values
    const Filters = {};
    Object.keys(inputs).forEach(
      key =>
        (Filters[key] =
          inputs[key] && inputs[key].value ? inputs[key].value : inputs[key])
    );
    delete Filters.Vehicle;
    setFilters({
      ...Filters,
      CreatedDateTime_gte: Filters.CreatedDateTime_gte
        ? Filters.CreatedDateTime_gte
        : new Date().setHours(0, 0, 0, 0) - 1000 * 60 * 60 * 24 * 365 * 2
    });
    saveFilterState("WORK_ORDERS_FILTERS", Filters);
  };
  const resetFilters = () => handleSetFilters({ ...DEFAULT_FILTERS });

  const parseFilters = input => {
    const where = { ...input };
    if (input.WODate_gte) {
      where.WODate_gte = moment(input.WODate_gte)
        .startOf("day")
        .toISOString();
    }
    if (input.WODate_lte) {
      where.WODate_lte = moment(input.WODate_lte)
        .endOf("day")
        .toISOString();
    }
    if (input.CompletedDate_gte) {
      where.CompletedDate_gte = moment(input.CompletedDate_gte)
        .startOf("day")
        .toISOString();
    }
    if (input.CompletedDate_lte) {
      where.CompletedDate_lte = moment(input.CompletedDate_lte)
        .endOf("day")
        .toISOString();
    }
    if (input.CreatedDateTime_gte) {
      where.CreatedDateTime_gte = moment(input.CreatedDateTime_gte)
        .startOf("day")
        .toISOString();
    }
    if (input.CreatedDateTime_lte) {
      where.CreatedDateTime_lte = moment(input.CreatedDateTime_lte)
        .endOf("day")
        .toISOString();
    }
    return where;
  };

  if (!filters.WOStatusRecIdRef_in) {
    return <Loading />;
  }

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={WorkOrderFilters}
        columns={WORK_ORDER_COLUMNS()}
        filters={parseFilters(filters)}
        name="VW_WorkOrdersByPage"
        query={ALL_WORK_ORDERS_VIEW_BY_PAGE_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Work Orders"
        onAddClick={() => history.push("/fleet/work-orders/0/main-information")}
      />
      <DataTable
        isPaginated
        columns={WORK_ORDER_COLUMNS()}
        dataQuery={ALL_WORK_ORDERS_VIEW_BY_PAGE_QUERY}
        hiddenColumns={["StatusListOrder"]}
        initialSortBy={[
          { id: "StatusListOrder", desc: false },
          { id: "WODate", desc: false }
        ]}
        name="VW_WorkOrdersByPage"
        where={parseFilters(filters)}
        onRowClick={data =>
          history.push(`/fleet/work-orders/${data.RecId}/main-information`)
        }
      />
    </React.Fragment>
  );
}

WorkOrdersPage.propTypes = {};
export default WorkOrdersPage;
